
export class ProductsType {
  public constructor(
    public productsTypeId?: number,
    public nameForSingle?: string,
    public nameForMany?: string
  ) {
  }
}
